<template>
      <button @click="click()" :data-to="to" :class="color+' '+type"><slot></slot></button>
</template>

<script>
export default {
  props: ['color', 'type', 'to', 'func'],
  data () {
    return {
    }
  },
  methods: {
    click:function(){
      if(this.to) {
        this.routePush(this.to, {item:'button', to:this.to});
      } else if(this.func) {
        if ( Array.isArray(this.funcParams) ){
          this.func.apply(this,this.funcParams);
        } else {
          this.func.apply(this,[this.funcParams]);
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/sass/_variables.scss";

$button-padding-v: 0.5em;
$button-padding-h: 2em;

button {
    font-family: $font-main;
    font-weight: 800;
    font-style: normal;
    text-decoration: none;
    font-size:1.3em;

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    @include for-size(phone-only) {
      font-size:2em;
      width:100%;
      padding: .3em 0em;
      margin:0!important;
    }
    @include for-size(tablet-portrait-up) {
      font-size:1.3em;
    }
    @include for-size(tablet-landscape-up) {
      font-size:1.2em;
    }

    align-self: start;
    border: 1px solid currentColor;
    box-sizing: border-box;
    padding: $button-padding-v $button-padding-h;
    background-color:transparent;
    position:relative;
    overflow:hidden;
    transition: .4s padding 0s ease, .3s transform 0s ease;

    &:before {
      transition: all .6s ease;
      width:100%;
      height:100%;
      content:"";
      position: absolute;
      top:0;
      left:-50%;
      background-repeat: no-repeat;
      background-position: center left;
      background-image: url(/static/img/Arrow.svg);
      background-size: auto 60%;
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          display: none;
      }
      @include for-size(phone-only) {
          display: none;
      }
    }

    &:hover {
      padding-left: calc( #{$button-padding-h} + 0.7em );
      padding-right: calc( #{$button-padding-h} - 0.7em );
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          padding: $button-padding-v $button-padding-h;
      }
      transition-delay: 0.4s, 0s;
      //animation: hue 10s infinite linear;
      &:before{
          left: -1em;
          @include for-size(phone-only) {
            left: -1.7em;
          }
      }
    }

    &:active {
      transform: scale(0.9);
    }

    &.red {
      color:$red-fill;
      &:before{
        background-image: url(/static/img/Arrow-red.svg);
      }
    }
    &.white{
      color:white;
    }
    &.black{
      color:black;
      &:before{
        filter: invert(1);
      }
    }
    &.transparent {
      background-color:transparent;
    }
    &.red-fill {
      background-color:$red-fill;
      border:2px solid $red-fill;
    }
    &.white-fill {
      background-color:white;
      border:2px solid white;
    }
    & + button {
      margin-left:1em;
      @include for-size(phone-only) {
        margin:1em 0!important;
      }
    }
}

@keyframes hue {
  from {
    filter: hue-rotate(0deg);
  }
  to {
    filter: hue-rotate(-360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/KmsButton.vue